import { render, staticRenderFns } from "./miniMap.vue?vue&type=template&id=0cff3b56&scoped=true&"
import script from "./miniMap.vue?vue&type=script&lang=js&"
export * from "./miniMap.vue?vue&type=script&lang=js&"
import style0 from "./miniMap.vue?vue&type=style&index=0&id=0cff3b56&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff3b56",
  null
  
)

export default component.exports